import { messages as englishMessages } from "./en";

const messages = {
	...englishMessages,
};

export { messages };
